import axios, { type AxiosError } from "axios";
import type { ContentAdapterAPI } from "generated/types";
import { type ApiRequestError, RequestError } from "models/error/Error";
import cookieStorage from "persistence";
import { handlingResponse, logError } from "repositories/utils";

// Fetch information on a module package from Edify
export const getEdifyModuleDetails = async (
  packageId: string,
): Promise<ContentAdapterAPI.EdifyModuleDetails> => {
  try {
    const moduleDetails = await axios.get(`/api/disco/module/${packageId}`, {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<ContentAdapterAPI.EdifyModuleDetails>(
      [200],
      "Error getting edify module details",
    )(moduleDetails);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      type: "getEdifyModuleDetailsFailed",
    });
  }
};

// Fetch information on a chapter from a module package in Edify
export const getEdifySubjectDetails = async (
  packageId: string,
  themeId: string,
): Promise<ContentAdapterAPI.EdifySubjectDetails> => {
  try {
    const subjectDetails = await axios.get(`/api/disco/module/${packageId}/subject/${themeId}`, {
      headers: { Authorization: cookieStorage.getToken() },
    });
    return handlingResponse<ContentAdapterAPI.EdifySubjectDetails>(
      [200],
      "Error getting edify subject details",
    )(subjectDetails);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      type: "getEdifySubjectDetailsFailed",
    });
  }
};

// Fetch information on a content unit within a specific chapter from a module package in Edify
export const getEdifyTopicDetails = async (
  packageId: string,
  themeId: string,
  contentUnitId: string,
): Promise<ContentAdapterAPI.EdifyTopicDetails> => {
  try {
    const topicDetails = await axios.get(
      `/api/disco/module/${packageId}/subject/${themeId}/topic/${contentUnitId}`,
      {
        headers: { Authorization: cookieStorage.getToken() },
      },
    );
    return handlingResponse<ContentAdapterAPI.EdifyTopicDetails>(
      [200],
      "Error getting edify topic details",
    )(topicDetails);
  } catch (error) {
    const { message, status } = logError(error as AxiosError<ApiRequestError>);
    throw new RequestError({
      message,
      status,
      type: "getEdifyTopicDetailsFailed",
    });
  }
};
